import { BindingError } from "../BindingError.js";
import { VariableFieldValue } from "../dao/VariableFieldValue.js";
class VariableInputTransformer {
  static transformValue(value, environment) {
    if (value instanceof VariableFieldValue) {
      return VariableInputTransformer.transformVariableFieldValue(value, environment);
    }
    return value;
  }
  static transformVariableFieldValue(variableFieldValue, environment) {
    const value = environment.getVariableOrElse(variableFieldValue.variableName, void 0) ?? environment.getParameterOrElse(variableFieldValue.variableName, void 0);
    if (value === void 0) {
      throw new BindingError(`Variable '${variableFieldValue.variableName}' not found.`);
    }
    if (typeof value !== "string" && typeof value !== "boolean" && typeof value !== "number" && value !== null) {
      throw new BindingError(`The value of the '${variableFieldValue.variableName}' must be a scalar or null, not '${typeof value}'.`);
    }
    return value;
  }
}
export {
  VariableInputTransformer
};
//# sourceMappingURL=VariableInputTransformer.js.map
